// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "vant/lib/index.css";
import axios from "axios";
import request from "@/request/http";
import FastClick from "fastclick";
FastClick.attach(document.body);
import common from "@/modules/common.js";
// import { voiceURL } from "@/request/otherApi.js";
import "./modules/directive";
import serverSocket from "@/utils/dcServer.js"
const getEnv = () => {
    let env = 'development'
    try {
        // console.log("%c 🍊 config", "color:#3f7cff", config);
        let arr = Object.keys(config)
        for (let i = 0; i < arr.length; i++) {
            let item = config[arr[i]]
            // console.log("%c 🥟 item", "color:#42b983", item);
            if (item.indexOf("demo") > -1) {
                env = 'development'
                return env
            }
        }
        env = 'production'
        return env
    } catch (err) {
        env = 'development'
        return env
    }
}
Vue.prototype.$serverSocket = serverSocket;
// Vue.prototype.$voiceURL = voiceURL;

// import Vconsole from "vconsole";
// let vConsole = new Vconsole();
// export default vConsole;

require("./components/index");

import "@vant/touch-emulator";
import {
    NavBar,
    Button,
    Tab,
    Tabs,
    IndexBar,
    IndexAnchor,
    Toast,
    Checkbox,
    CheckboxGroup,
    DropdownMenu,
    DropdownItem,
    PullRefresh,
    RadioGroup,
    Radio,
    Dialog,
    Popup,
    Form,
    Field,
    Picker,
    Uploader,
    Icon,
    Switch,
    List,
    Tag,
    SwitchCell,
    Cell,
    Calendar,
    Pagination,
    Loading,
    Overlay,
    Search,
    Stepper,
    DatetimePicker,
    Collapse,
    CollapseItem,
    NumberKeyboard,
    Popover,
    NoticeBar,
    Swipe,
    SwipeItem,
    Notify,
} from "vant";
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Tab).use(Tabs);
Vue.use(IndexBar).use(IndexAnchor);
Vue.use(Toast);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(PullRefresh);
Vue.use(Radio);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Switch);
Vue.use(List);
Vue.use(Tag);
Vue.use(SwitchCell);
Vue.use(Cell);
Vue.use(Calendar);
Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Search);
Vue.use(Stepper);
Vue.use(DatetimePicker);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(NumberKeyboard);
Vue.use(Popover);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Toast.setDefaultOptions({ position: "top" });
Toast.setDefaultOptions({ duration: 3000 });
Toast.setDefaultOptions({ forbidClick: false });
Vue.use(Notify);

Vue.config.productionTip = false;
import api from "@/request/api";
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$request = request;
Vue.prototype.isNull = common.isNull;

import sidebar from "@/components/sidebar";
Vue.component("sidebar", sidebar);

/* eslint-disable no-new */
import bus from "vue-bus";
Vue.use(bus);

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import device from "@/utils/device";
Vue.prototype.$device = device;

// 自适应
fnResize();
window.onresize = function () {
    fnResize();
};

function fnResize() {
    setTimeout(() => {
        var deviceWidth =
            document.documentElement.clientWidth || window.innerWidth;
        var test = deviceWidth / 27.32;
        if (test >= 49 && test <= 51) {
            document.documentElement.style.fontSize =
                deviceWidth / 27.32 + "px";
        } else {
            document.documentElement.style.fontSize =
                deviceWidth / (27.32 * 1.15) + "px";
        }
    }, 500);
}

//路由跳转
function push(e) {
    //console.log(e);
    router.push({ name: e[2], params: { activeMenu: e[1] } }, onComplete => { }, onAbort => { });
}
Vue.prototype.$push = push;

//input获取焦点不调出输入法
// function stopKeyborad() {
//   this.$refs.scanTextbox.setAttribute("readonly", "readonly");
//   setTimeout(() => {
//     this.$refs.scanTextbox.removeAttribute("readonly");
//   }, 200);
// }
// Vue.prototype.stopKeyborad = stopKeyborad
Vue.config.errorHandler = function (err, vm, info) {
    alert(err)
};

new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App/>"
});





// WEBPACK FOOTER //
// ./src/main.js